import { AxDropdown } from "@axess/limestone";
import { BehaviorSubject } from "rxjs";
import { AxDatePicker, Cell, Mode } from "../../Components/AxDatepicker/AxDatepicker";
import { BodyUtility } from "../../Components/AxUtility/BodyUtility";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from '../../Lib/Helper/I18nHelper';
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { RentalSelectionItem } from "../../Models/Rental/RentalSelectionItem";
import { RentalFilterPriceSlider } from "./Components/RentalFilterPriceSlider";
import { RentalFilterResetHelper } from "./Helper/RentalFilterResetHelper";

@ModuleName("RentalFilter")
export class RentalFilter implements AxInit {
    public _durationDropDown: AxDropdown = new AxDropdown();
    public _locationDropDown: AxDropdown = new AxDropdown();
    public _dateDropDown: AxDropdown = new AxDropdown();

    public datePicker: AxDatePicker;
    public rentalItemList: RentalSelectionItem[];

    public options: IRentalFilterInitData;
    public filterUpdateAllowed: boolean = false;

    private datePickerActivationSubject: BehaviorSubject<Cell>;

    private rentalPriceFilter: RentalFilterPriceSlider;

    private tmpFilters: IFilterRequest;

    constructor(private _axLoading = new AxLoading(),
        private _bodyUtility = new BodyUtility(),
        private _requestHelper = new RequestHelper(),
        private _filterResetHelper = new RentalFilterResetHelper(),
        private i18nHelper = new I18nHelper()) { }

    AxInit(init: IRentalFilterInitData): void {
        this.options = init;
        this.rentalPriceFilter = new RentalFilterPriceSlider(this);

        this.initFilterInputs();
        this.attachMenuEvents();
        this.initQueryParameters();

        this._filterResetHelper.init(this);
    }

    toggleFilterBar(active: boolean) {
        $('.rental__filter_bar').toggleClass('active', active);
    }

    printFilterCount(count: number) {
        $('.rental__filter_filterWrapper, .rental__filter_filterCount').toggleClass('d-none', count === 0);
        $('.rental__filter_filterCount').html(`${count}`);
    }

    printItemCount(count: number) {
        $('.rental__filter_itemCount').html(`${count}`);
        $('.rental__filter_itemText').html(this.i18nHelper.GetTranslation(Translations.ShowXResults, count));
    }

    attachMenuEvents() {
        $('.rental__filter-catinfo').on('click', '.rental__filter_settings', e => {
            window.scrollTo(0, 0);
            this.toggleFilterBar(true);
            this._bodyUtility.DisableScroll();
            this.tmpFilters = this.getFilterRequest();
        });

        $('.prod_selection__prod-save').click(e => {
            this.toggleFilterBar(false);
            this._bodyUtility.EnableScroll();
        });

        $('.rental__filter_bar .retail__filter_settings-close').click(e => {
            this.resetFilterFromTmp();
            this.toggleFilterBar(false);
            this._bodyUtility.EnableScroll();
        });

        $('.rental__filter_bar .prod_selection__prod-close').click(e => {
            this.toggleFilterBar(false);
            this._filterResetHelper.resetAllFilters();
        });
    }

    initFilterInputs() {
        this.rentalPriceFilter.setPriceFilter();
        this.datePicker = new AxDatePicker();

        let endDate = this.options?.endDate ? moment(this.options.endDate, "YYYY-MM-DD") : null;
        const blockedDates = this.options?.closedDays?.map(x => moment(x, "YYYY-MM-DD"));

        this.datePicker.Init({
            StartOfWeek: this.options.startOfWeek,
            Lang: this.options.lang,
            StartDate: moment(this.options.startDate, "YYYY-MM-DD"),
            DayRange: 0,
            Target: '#rental__startDate-picker',
            Mode: Mode.Inline,
            EndDate: endDate,
            monthsShown: 1,
            BlockedDates: blockedDates,
        });

        this._durationDropDown.init(`.rental_landing__duration`,
            {
                searchBar: true,
                multiSelect: false,
                onSelect: (parent, element) => { this.updateFilterItems() }
            });
        this._locationDropDown.init(`.rental_landing__location`,
            {
                searchBar: true,
                multiSelect: false,
                onSelect: (parent, element) => { this.updateFilterItems() }
            });

        this._dateDropDown.init(`.rental_landing__date`,
            {
                searchBar: false,
                multiSelect: false
            });


        $('input[name=rental_landing__cat]').on('change',
            () => {
                this.updateFilterItems();
            });


        this.datePickerActivationSubject = this.datePicker.ActivationSubject;
        this.datePickerActivationSubject.subscribe(x => { this.setDate(x); });
    }

    private resetFilterFromTmp() {
        this.filterUpdateAllowed = false;

        if (this.tmpFilters.arcId == null) {
            this._locationDropDown.resetSelection();
        } else {
            this._locationDropDown.setValue(this.tmpFilters.arcId);
        }

        if (this.tmpFilters.durationIdentifier == null) {
            this._durationDropDown.resetSelection();
        } else {
            this._durationDropDown.setValue(this.tmpFilters.durationIdentifier);
        }

        if (this.tmpFilters.date == null) {
            this.datePicker.resetDateSelection();;
            this._dateDropDown.resetSelection();
        } else {
            this.datePicker.setDate(moment(this.tmpFilters.date, 'YYYY-MM-YY'));
        }

        $(`input[name=rental_landing__cat]`).prop('checked', false);
        $(`input[name=rental_landing__cat][value="${this.tmpFilters.catId}"]`).prop('checked', true);

        this.filterUpdateAllowed = true;
        this.updateFilterItems();
    }

    public getFilterParameterAndUpdateCount(request?: IFilterRequest) {
        let url = this.options.filterUrl;
        request = request || this.getFilterRequest();
        let filterCount = 0;

        if (request.catId != null && request.catId != 'null') {
            url += `/${request.catId}`;
            filterCount++;
        }

        if (request.durationIdentifier != null) {
            url = this._requestHelper.insertParam(url, "dId", request.durationIdentifier);
            filterCount++;
        }
        if (request.arcId != null) {
            url = this._requestHelper.insertParam(url, "aId", request.arcId);
            filterCount++;
        }
        if (request.date != null && request.date != null) {
            url = this._requestHelper.insertParam(url, "date", request.date);
            filterCount++;
        }

        let rangeSlider = $("#retail__filter__price_slider").data("ionRangeSlider");

        if (!$(".retail__filter__price_holder").hasClass('d-none') && rangeSlider != null && (rangeSlider.result.min !== rangeSlider.result.from || rangeSlider.result.max !== rangeSlider.result.to)) {
            filterCount++;
        }

        this.printFilterCount(filterCount);
        return url;
    }

    updateFilterItems(requestObj?: IFilterRequest) {
        if (!this.filterUpdateAllowed) return;

        requestObj = requestObj || this.getFilterRequest();

        const urlPath = this.getFilterParameterAndUpdateCount(requestObj);
        window.history.pushState({}, "", urlPath);

        this._axLoading.ShowLoadingIndicatorFixed($('.rental__filter-item-wrapper')[0]);
        AxessViewer.loadPartialView('/Rental/FilterPartial',
            requestObj,
            (x: IRentalFilterResult) => {
                this.rentalItemList = x.selectionItems;
                $('.rental__filter-itemList').html(x.returnView);
                $('.rental__filter-catinfo').html(x.catView);
                this.printItemCount(this.rentalItemList.length);
                this.rentalPriceFilter.setPriceFilter();
                this._axLoading.HideLoadingIndicator($('.rental__filter-item-wrapper')[0]);
                this.getFilterParameterAndUpdateCount(requestObj);
            }, {});
    }

    getFilterRequest(): IFilterRequest {
        const arcId = this._locationDropDown.getValue() as string;
        const durationIdentifier = this._durationDropDown.getValue() as string;
        const dateCell: Cell = this.datePickerActivationSubject.getValue();
        const catId = $('input[name=rental_landing__cat]:checked').val() as string;

        let date = null;
        if (dateCell != null) {
            date = dateCell.Date.format('YYYY-MM-DD');
        }

        const requestObj: IFilterRequest = {
            arcId,
            durationIdentifier,
            date,
            catId
        };

        return requestObj;
    }

    initQueryParameters() {
        const dateRaw = this._requestHelper.findGetParameter('date');
        const arcId = this._requestHelper.findGetParameter('aId');
        const durationId = this._requestHelper.findGetParameter('dId');

        if (dateRaw != null) {
            const date = moment(this._requestHelper.findGetParameter('date'), "YYYY-MM-DD");
            this.datePicker.setDate(date);
        }
        if (arcId != null) {
            this._locationDropDown.setValue(arcId);
        }
        if (durationId != null) {
            this._durationDropDown.setValue(durationId);
        }
        if (this.options.initialCatId) {
            $(`input[name=rental_landing__cat][value="${this.options.initialCatId}"]`).prop('checked', true);
        }

        this.filterUpdateAllowed = true;     
        this.updateFilterItems();
    }

    setDate(cell: Cell) {
        if (cell != null) {
            this._dateDropDown.setValue(cell.Date.format(this.options.datePattern));
            this._dateDropDown.close();
            this.updateFilterItems();
        }
    }
}

interface IRentalFilterResult {
    returnView: HTMLElement;
    catView: HTMLElement;
    selectionItems: RentalSelectionItem[];
}

interface IFilterRequest {
    arcId: string;
    durationIdentifier: string;
    date: string;
    catId: string;
}


interface IRentalFilterInitData {
    filterUrl: string;
    startOfWeek: number;
    startDate: string;
    endDate?: string;
    datePattern: string;
    lang: string;
    currencyString: string;
    closedDays: string[];
    initialCatId?: string;
}